import { Component, OnInit } from '@angular/core';
import { TokenStorage } from '../../../../storages/token.storage';
import { Router } from '@angular/router';
import { NavbarInfoService } from '../../services/navbar-info.service';
import { LoggingService } from '../../../../services/logging.service';

declare var $: any;

@Component({
  selector: 'app-home-navigate-bar',
  templateUrl: './home-navigate-bar.component.html',
  styleUrls: ['./home-navigate-bar.component.sass']
})
export class HomeNavigateBarComponent implements OnInit {

  modelInfo: any;

  constructor(private token: TokenStorage, private router: Router, private info: NavbarInfoService, private loggingService: LoggingService) {
    this.modelInfo = {};
  }

  ngOnInit() {
    this.info.get().subscribe(info => {
      if (info != null) {
        this.modelInfo.name = info["name"];
      }
    });
  }

  logout(): void {
    const _xid = this.loggingService.generateUUID();
    
    try {
      this.loggingService.logStart(_xid, 'App.Components.HomeNavigateBarComponent.logout', null, 'User logout started');
      
      this.token.signOut();
      
      this.loggingService.logFinish(_xid, 'App.Components.HomeNavigateBarComponent.logout', null, 'User logged out');
    } catch (_error) {
      this.loggingService.logError(_xid, 'App.Components.HomeNavigateBarComponent.logout', _error, null, 'Logout failed');
      throw _error;
    }
  }

  fileExportExample(){
    
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/home/components/home-navigate-bar/home-navigate-bar.component.ts